import * as Sentry from '@sentry/angular-ivy';

// Envia ao Sentry uma falha do fluxo de autorização: somente a mensagem do erro e o stack trace
// (nunca para o console do navegador, e sem tag, id, usuário, senha ou token).
export function registrarFalhaDeAutorizacao(erro: unknown, mensagem: string): void {
    // Com uma exceção real, o Sentry recebe a mensagem e o stack trace dela; sem exceção (falha devolvida pela API), cria um erro com a mensagem
    const excecao = erro instanceof Error ? erro : new Error(mensagem);

    Sentry.captureException(excecao);
}
